import { Component, ComponentFactoryResolver, Injector, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Action, CrudEditComponent, CrudEditorParentService, CrudEditorSelfService, UserStorage } from '@scisys-uim/uim-common';
import { Asset, ASSET_TYPE, TRANSFER_ASSET_TYPE } from 'assets-model';
import { AssetItemComponent } from './asset-item.component';
import { ASSET_MAINTENANCE_METADATA } from 'dist/assets-model/lib/domain/assetmaintenance/model/asset-maintenance.metadata';
import { ASSET_MAINTENANCE_TYPE } from 'projects/assets-model/src/lib/domain/assetmaintenance/model/asset-maintenance.typeinfo';


@Component({
  selector: 'app-asset-editor',
  templateUrl: '../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.html',
  styleUrls: ['../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.css'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class AssetEditorComponent extends CrudEditComponent<Asset, number> implements OnInit {

  get assetItemComponent(): AssetItemComponent {
    return <AssetItemComponent>this.itemComponent;
  }

  constructor(
    route: ActivatedRoute,
    router: Router,
    userStorage: UserStorage,
    dialog: MatDialog,
    snackbar: MatSnackBar,
    componentFactoryResolver: ComponentFactoryResolver,
    injector: Injector) {
    super(route, router, userStorage, dialog, snackbar, componentFactoryResolver, injector);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  itemSet() {
    super.itemSet();
    const self = this;
    this.actions = [];
    if (!this.createMode) {
      if (!this.readOnly) {
        this.actions.push(<Action>{
          title: 'Transfer Asset',
          get enabled(): boolean {
            return self.isTransferAssetEnabled();
          },
          color: true,
          get available(): boolean {
            return !self.readOnly && self.userStorage.currentUserHasAnyAuthority(TRANSFER_ASSET_TYPE.editAuthorities);
          },
          doAction() {
            self.transferAssetAction();
          }
        });
      }
      this.actions.push(<Action>{
        title: 'Audit',
        get enabled(): boolean {
          return true;
        },
        color: true,
        get available(): boolean {
          return self.item?.assetId != null;
        },
        get route() {
          return [...ASSET_TYPE.auditRouteBase, self.item?.assetId]
        },
        getQueryParams() {
          return self.backRouteQueryParams();
        }
      });

      this.actions.push(<Action>{
        title: 'Maintenance',
        get enabled(): boolean {
          return true;
        },
        color: true,
        get available(): boolean {
          return self.item?.assetId != null && !self.readOnly && self.userStorage.currentUserHasAnyAuthority(ASSET_MAINTENANCE_TYPE.editAuthorities);;
        },
        get route() {
          return [...ASSET_MAINTENANCE_TYPE.searchRouteBase, self.item?.assetId, self.item?.composedAssetClass]
        }
      });
    }
  }

  isTransferAssetEnabled(): boolean {
    return this.assetItemComponent.isTransferAssetEnabled();
  }

  transferAssetAction() {
    this.assetItemComponent.launchTransferAssetDialog()
  }

}






